import type { FieldDependsOnDescriptor } from '../../fields/types/common';
import type { DependenciesFormValues } from '../../types/FormValues';
import { checkDependencyChanged } from './checkDependencyChanged';

export const shouldPreserveFieldValue = (
  prevDependencyValues: DependenciesFormValues,
  currentDependencyValues: DependenciesFormValues,
  sectionKey: string,
  dependsOn: FieldDependsOnDescriptor[] = []
): boolean => {
  if (dependsOn.length === 0) {
    return false;
  }

  for (const dependency of dependsOn) {
    const dependencyChanged = checkDependencyChanged(
      dependency,
      prevDependencyValues,
      currentDependencyValues,
      sectionKey
    );

    if (dependencyChanged && dependency.preserveOnChange) {
      return true;
    }
  }

  return false;
};
